import React, { useEffect, useState } from 'react';
import NavBar from '../components/Navbar/NavBar';
import Footer from '../components/Footer';
import { useDocTitle } from '../components/CustomHook';
import DatePicker from 'react-datepicker';
import emailjs from '@emailjs/browser';
import Notiflix from 'notiflix';
import { motion, AnimatePresence } from 'framer-motion';
import { Mail, Phone, Calendar, Users, MapPin, Building2, Sparkles, Menu, ArrowRight, User } from 'lucide-react';
import 'react-datepicker/dist/react-datepicker.css';
import "../../src/custom-datepicker.css";

const Contact = () => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [message, setMessage] = useState('');
    const [selectedDate, setSelectedDate] = useState(null);
    const [guestsNumber, setGuestsNumber] = useState('');
    const [venue, setVenue] = useState('');
    const [eventType, setEventType] = useState('');
    const [errors, setErrors] = useState([]);
    const [agency, setAgency] = useState('');
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [countryCode, setCountryCode] = useState('+216'); // Default to UAE

   const countryCodes = [
  { code: '+1', label: '🇺🇸 United States / Canada', iso: 'US' },
  { code: '+7', label: '🇷🇺 Russia', iso: 'RU' },
  { code: '+20', label: '🇪🇬 Egypt', iso: 'EG' },
  { code: '+27', label: '🇿🇦 South Africa', iso: 'ZA' },
  { code: '+30', label: '🇬🇷 Greece', iso: 'GR' },
  { code: '+31', label: '🇳🇱 Netherlands', iso: 'NL' },
  { code: '+32', label: '🇧🇪 Belgium', iso: 'BE' },
  { code: '+33', label: '🇫🇷 France', iso: 'FR' },
  { code: '+34', label: '🇪🇸 Spain', iso: 'ES' },
  { code: '+36', label: '🇭🇺 Hungary', iso: 'HU' },
  { code: '+39', label: '🇮🇹 Italy', iso: 'IT' },
  { code: '+40', label: '🇷🇴 Romania', iso: 'RO' },
  { code: '+41', label: '🇨🇭 Switzerland', iso: 'CH' },
  { code: '+44', label: '🇬🇧 United Kingdom', iso: 'GB' },
  { code: '+45', label: '🇩🇰 Denmark', iso: 'DK' },
  { code: '+46', label: '🇸🇪 Sweden', iso: 'SE' },
  { code: '+47', label: '🇳🇴 Norway', iso: 'NO' },
  { code: '+48', label: '🇵🇱 Poland', iso: 'PL' },
  { code: '+49', label: '🇩🇪 Germany', iso: 'DE' },
  { code: '+51', label: '🇵🇪 Peru', iso: 'PE' },
  { code: '+52', label: '🇲🇽 Mexico', iso: 'MX' },
  { code: '+53', label: '🇨🇺 Cuba', iso: 'CU' },
  { code: '+54', label: '🇦🇷 Argentina', iso: 'AR' },
  { code: '+55', label: '🇧🇷 Brazil', iso: 'BR' },
  { code: '+56', label: '🇨🇱 Chile', iso: 'CL' },
  { code: '+57', label: '🇨🇴 Colombia', iso: 'CO' },
  { code: '+58', label: '🇻🇪 Venezuela', iso: 'VE' },
  { code: '+60', label: '🇲🇾 Malaysia', iso: 'MY' },
  { code: '+61', label: '🇦🇺 Australia', iso: 'AU' },
  { code: '+62', label: '🇮🇩 Indonesia', iso: 'ID' },
  { code: '+63', label: '🇵🇭 Philippines', iso: 'PH' },
  { code: '+64', label: '🇳🇿 New Zealand', iso: 'NZ' },
  { code: '+65', label: '🇸🇬 Singapore', iso: 'SG' },
  { code: '+66', label: '🇹🇭 Thailand', iso: 'TH' },
  { code: '+81', label: '🇯🇵 Japan', iso: 'JP' },
  { code: '+82', label: '🇰🇷 South Korea', iso: 'KR' },
  { code: '+84', label: '🇻🇳 Vietnam', iso: 'VN' },
  { code: '+86', label: '🇨🇳 China', iso: 'CN' },
  { code: '+90', label: '🇹🇷 Turkey', iso: 'TR' },
  { code: '+91', label: '🇮🇳 India', iso: 'IN' },
  { code: '+92', label: '🇵🇰 Pakistan', iso: 'PK' },
  { code: '+93', label: '🇦🇫 Afghanistan', iso: 'AF' },
  { code: '+94', label: '🇱🇰 Sri Lanka', iso: 'LK' },
  { code: '+95', label: '🇲🇲 Myanmar', iso: 'MM' },
  { code: '+98', label: '🇮🇷 Iran', iso: 'IR' },
  { code: '+211', label: '🇸🇸 South Sudan', iso: 'SS' },
  { code: '+212', label: '🇲🇦 Morocco', iso: 'MA' },
  { code: '+213', label: '🇩🇿 Algeria', iso: 'DZ' },
  { code: '+216', label: '🇹🇳 Tunisia', iso: 'TN' },
  { code: '+218', label: '🇱🇾 Libya', iso: 'LY' },
  { code: '+220', label: '🇬🇲 Gambia', iso: 'GM' },
  { code: '+221', label: '🇸🇳 Senegal', iso: 'SN' },
  { code: '+225', label: '🇨🇮 Côte d\'Ivoire', iso: 'CI' },
  { code: '+234', label: '🇳🇬 Nigeria', iso: 'NG' },
  { code: '+237', label: '🇨🇲 Cameroon', iso: 'CM' },
  { code: '+254', label: '🇰🇪 Kenya', iso: 'KE' },
  { code: '+263', label: '🇿🇼 Zimbabwe', iso: 'ZW' },
  { code: '+971', label: '🇦🇪 United Arab Emirates', iso: 'AE' },
  { code: '+972', label: '🇮🇱 Israel', iso: 'IL' },
  { code: '+974', label: '🇶🇦 Qatar', iso: 'QA' },
  { code: '+975', label: '🇧🇹 Bhutan', iso: 'BT' },
  { code: '+977', label: '🇳🇵 Nepal', iso: 'NP' },
  { code: '+994', label: '🇦🇿 Azerbaijan', iso: 'AZ' },
];


        useEffect(() => {
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

            const handleScroll = () => {
                const currentScrollPos = window.pageYOffset;
                setIsVisible(currentScrollPos > 100);
            };

            window.addEventListener('scroll', handleScroll);
            return () => window.removeEventListener('scroll', handleScroll);
        }, []);

    const eventTypes = [
        'Wedding',
        'Engagement',
        'Corporate Event',
        'Birthday Party',
        'Anniversary',
        'Graduation',
        'Other'
    ];

    const clearErrors = () => setErrors([]);
    const clearInput = () => {
        setFirstName('');
        setLastName('');
        setEmail('');
        setPhone('');
        setMessage('');
        setSelectedDate(null);
        setGuestsNumber('');
        setVenue('');
        setAgency('');

        setEventType('');
    };
    const validateForm = () => {
        const newErrors = {};

        if (!firstName.trim()) {
            newErrors.first_name = 'First name is required';
            Notiflix.Notify.failure('First name is required', {
                position: 'right-top',
                distance: '30px',
                fontSize: '18px',
                width: '400px',
                cssAnimationStyle: 'zoom',
                cssAnimationDuration: 400,
                timeout: 3000,
                useIcon: true,
                borderRadius: '12px',
            });
            setErrors(newErrors);
            return false; // Stop after the first error
        }

        if (!lastName.trim()) {
            newErrors.last_name = 'Last name is required';
            Notiflix.Notify.failure('Last name is required', {
                position: 'right-top',
                distance: '30px',
                fontSize: '18px',
                width: '400px',
                cssAnimationStyle: 'zoom',
                cssAnimationDuration: 400,
                timeout: 3000,
                useIcon: true,
                borderRadius: '12px',
            });
            setErrors(newErrors);
            return false; // Stop after the first error
        }

        if (!email.trim()) {
            newErrors.email = 'Email is required';
            Notiflix.Notify.failure('Email is required', {
                position: 'right-top',
                distance: '30px',
                fontSize: '18px',
                width: '400px',
                cssAnimationStyle: 'zoom',
                cssAnimationDuration: 400,
                timeout: 3000,
                useIcon: true,
                borderRadius: '12px',
            });
            setErrors(newErrors);
            return false; // Stop after the first error
        }

        if (!phone.trim()) {
            newErrors.phone_number = 'Phone number is required';
            Notiflix.Notify.failure('Phone number is required', {
                position: 'right-top',
                distance: '30px',
                fontSize: '18px',
                width: '400px',
                cssAnimationStyle: 'zoom',
                cssAnimationDuration: 400,
                timeout: 3000,
                useIcon: true,
                borderRadius: '12px',
            });
            setErrors(newErrors);
            return false; // Stop after the first error
        }

        if (!message.trim()) {
            newErrors.message = 'Message is required';
            Notiflix.Notify.failure('Message is required', {
                position: 'right-top',
                distance: '30px',
                fontSize: '18px',
                width: '400px',
                cssAnimationStyle: 'zoom',
                cssAnimationDuration: 400,
                timeout: 3000,
                useIcon: true,
                borderRadius: '12px',
            });
            setErrors(newErrors);
            return false; // Stop after the first error
        }

        if (!selectedDate) {
            newErrors.date = 'Event date is required';
            Notiflix.Notify.failure('Event date is required', {
                position: 'right-top',
                distance: '30px',
                fontSize: '18px',
                width: '400px',
                cssAnimationStyle: 'zoom',
                cssAnimationDuration: 400,
                timeout: 3000,
                useIcon: true,
                borderRadius: '12px',
            });
            setErrors(newErrors);
            return false; // Stop after the first error
        }

        if (!guestsNumber.trim()) {
            newErrors.guests_number = 'Number of guests is required';
            Notiflix.Notify.failure('Number of guests is required', {
                position: 'right-top',
                distance: '30px',
                fontSize: '18px',
                width: '400px',
                cssAnimationStyle: 'zoom',
                cssAnimationDuration: 400,
                timeout: 3000,
                useIcon: true,
                borderRadius: '12px',
            });
            setErrors(newErrors);
            return false; // Stop after the first error
        }

        if (!venue.trim()) {
            newErrors.venue = 'Venue details are required';
            Notiflix.Notify.failure('Venue details are required', {
                position: 'right-top',
                distance: '30px',
                fontSize: '18px',
                width: '400px',
                cssAnimationStyle: 'zoom',
                cssAnimationDuration: 400,
                timeout: 3000,
                useIcon: true,
                borderRadius: '12px',
            });
            setErrors(newErrors);
            return false; // Stop after the first error
        }
        if (!agency) {
            newErrors.agency = 'Agency selection is required';
            Notiflix.Notify.failure('Agency selection is required', {
                position: 'right-top',
                distance: '30px',
                fontSize: '18px',
                width: '400px',
                cssAnimationStyle: 'zoom',
                cssAnimationDuration: 400,
                timeout: 3000,
                useIcon: true,
                borderRadius: '12px',
            });
            setErrors(newErrors);
            return false;
        }

        if (!eventType) {
            newErrors.event_type = 'Event type is required';
            Notiflix.Notify.failure('Event type is required', {
                position: 'right-top',
                distance: '30px',
                fontSize: '18px',
                width: '400px',
                cssAnimationStyle: 'zoom',
                cssAnimationDuration: 400,
                timeout: 3000,
                useIcon: true,
                borderRadius: '12px',
            });
            setErrors(newErrors);
            return false; // Stop after the first error
        }

        setErrors(newErrors);
        return true; // If no errors, return true
    };
    const sendEmail = (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        document.getElementById('submitBtn').disabled = true;
        document.getElementById('submitBtn').innerHTML = 'Loading...';

        const templateParams = {
            to_email: 'contact@2kevents.ae',
            from_name: `${firstName} ${lastName}`,
            from_email: email,
            phone_number: countryCode + phone,
            message: message,
            event_date: selectedDate ? selectedDate.toDateString() : '',
            guests_number: guestsNumber,
            venue: venue,
            event_type: eventType,
            reply_to: email,
        };

        emailjs.send(
            'service_c1xz4dh',
            'template_ptlw371',
            templateParams,
            'SdGgF6PZa0vbc7YeL'
        )
            .then((response) => {
                document.getElementById('submitBtn').disabled = false;
                document.getElementById('submitBtn').innerHTML = 'Send Message';
                clearInput();
                Notiflix.Report.success(
                    'Success',
                    'Your message has been sent successfully!',
                    'Okay'
                );
            })
            .catch((error) => {
                document.getElementById('submitBtn').disabled = false;
                document.getElementById('submitBtn').innerHTML = 'Send Message';
                Notiflix.Report.failure(
                    'An error occurred',
                    'Failed to send message. Please try again later.',
                    'Okay'
                );
            });
    };

    return (
        <div className="min-h-screen bg-gradient-to-b from-black via-gray-900 to-black text-white overflow-hidden">
            <NavBar />

            {/* Mobile Navigation Menu */}

            {/* Contact Form Section */}
            <section id="form" className="py-16 sm:py-32 px-4 sm:px-6">
                <div className="container mx-auto max-w-4xl">
                    <motion.div
                        initial={{ opacity: 0, y: 50 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        className="backdrop-blur-xl bg-white/5 rounded-3xl p-8 sm:p-12 border border-white/10"
                    >
                        <motion.h2
                            className="text-3xl sm:text-4xl font-bold mb-8 text-center bg-gradient-to-r from-white via-purple-400 to-blue-400 bg-clip-text text-transparent"
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: 0.2 }}
                        >
                            Begin Your Journey
                        </motion.h2>

                        <form onSubmit={sendEmail} className="space-y-8">
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
                                <motion.div
                                    initial={{ opacity: 0, x: -20 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ delay: 0.3 }}
                                    className="relative"
                                >
                                    <label className="block text-sm font-medium text-gray-300 mb-2">First Name</label>
                                    <div className="relative">
                                        <input
                                            type="text"
                                            value={firstName}
                                            onChange={(e) => setFirstName(e.target.value)}
                                            className="w-full pl-12 pr-4 py-3 bg-white/10 border border-white/20 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-400 text-white placeholder-gray-400"
                                            placeholder="Enter your first name"
                                        />
                                        <User className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                                    </div>
                                </motion.div>

                                <motion.div
                                    initial={{ opacity: 0, x: 20 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ delay: 0.4 }}
                                    className="relative"
                                >
                                    <label className="block text-sm font-medium text-gray-300 mb-2">Last Name</label>
                                    <div className="relative">
                                        <input
                                            type="text"
                                            value={lastName}
                                            onChange={(e) => setLastName(e.target.value)}
                                            className="w-full pl-12 pr-4 py-3 bg-white/10 border border-white/20 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-400 text-white placeholder-gray-400"
                                            placeholder="Enter your last name"
                                        />
                                        <User className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                                    </div>
                                </motion.div>
                            </div>

                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: 0.5 }}
                                className="relative"
                            >
                                <label className="block text-sm font-medium text-gray-300 mb-2">Email</label>
                                <div className="relative">
                                    <input
                                        type="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        className="w-full pl-12 pr-4 py-3 bg-white/10 border border-white/20 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-400 text-white placeholder-gray-400"
                                        placeholder="Enter your email"
                                    />
                                    <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                                </div>
                            </motion.div>

                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: 0.6 }}
                                className="relative"
                            >
                                <label className="block text-sm font-medium text-gray-300 mb-2">Phone</label>
                                <div className="relative flex">
                                    <div className="relative">
                                        <select
                                            value={countryCode}
                                            onChange={(e) => setCountryCode(e.target.value)}
                                            className="w-24 pl-9 pr-2 py-3 bg-white/10 border border-white/20 rounded-l-lg focus:outline-none focus:ring-2 focus:ring-purple-400 text-white appearance-none [&>option]:bg-gray-900 [&>option]:text-white"
                                        >
                                            {countryCodes.map((country) => (
                                                <option key={country.code} value={country.code}>
                                                    {country.code}
                                                </option>
                                            ))}
                                        </select>
                                        <Phone className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                                    </div>
                                    <input
                                        type="tel"
                                        value={phone}
                                        onChange={(e) => setPhone(e.target.value.replace(/\D/g, ''))}
                                        className="w-full pl-4 pr-4 py-3 bg-white/10 border-l-0 border border-white/20 rounded-r-lg focus:outline-none focus:ring-2 focus:ring-purple-400 text-white placeholder-gray-400"
                                        placeholder="Enter your phone number"
                                    />
                                </div>
                            </motion.div>
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
                                <motion.div
                                    initial={{ opacity: 0, x: -20 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ delay: 0.7 }}
                                    className="relative"
                                >
                                    <label className="block text-sm font-medium text-gray-300 mb-2">Event Date</label>
                                    <div className="relative">
                                        <DatePicker
                                            selected={selectedDate}
                                            onChange={(date) => setSelectedDate(date)}
                                            className="w-full pl-12 pr-4 py-3 bg-white/10 border border-white/20 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-400 text-white placeholder-gray-400"
                                            placeholderText="Select event date"
                                        />
                                        <Calendar className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                                    </div>
                                </motion.div>

                                <motion.div
                                    initial={{ opacity: 0, x: 20 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ delay: 0.8 }}
                                    className="relative"
                                >
                                    <label className="block text-sm font-medium text-gray-300 mb-2">Number of Guests</label>
                                    <div className="relative">
                                        <input
                                            type="number"
                                            value={guestsNumber}
                                            onChange={(e) => setGuestsNumber(e.target.value)}
                                            className="w-full pl-12 pr-4 py-3 bg-white/10 border border-white/20 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-400 text-white placeholder-gray-400"
                                            placeholder="Enter number of guests"
                                        />
                                        <Users className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                                    </div>
                                </motion.div>
                            </div>

                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: 0.9 }}
                                className="relative"
                            >
                                <label className="block text-sm font-medium text-gray-300 mb-2">Venue</label>
                                <div className="relative">
                                    <input
                                        type="text"
                                        value={venue}
                                        onChange={(e) => setVenue(e.target.value)}
                                        className="w-full pl-12 pr-4 py-3 bg-white/10 border border-white/20 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-400 text-white placeholder-gray-400"
                                        placeholder="Enter venue details"
                                    />
                                    <MapPin className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                                </div>
                            </motion.div>

                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
                                <motion.div
                                    initial={{ opacity: 0, x: -20 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ delay: 1 }}
                                    className="relative"
                                >
                                    <label className="block text-sm font-medium text-gray-300 mb-2">Event Type</label>
                                    <div className="relative">
                                        <select
                                            value={eventType}
                                            onChange={(e) => setEventType(e.target.value)}
                                            className="w-full pl-12 pr-4 py-3 bg-white/10 border border-white/20 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-400 text-white placeholder-gray-400 appearance-none [&>option]:bg-gray-900 [&>option]:text-white"
                                        >
                                            <option value="" className="text-gray-400">Select event type</option>
                                            {eventTypes.map((type) => (
                                                <option key={type} value={type} className="text-white">{type}</option>
                                            ))}
                                        </select>
                                        <Building2 className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                                    </div>
                                </motion.div>

                                <motion.div
                                    initial={{ opacity: 0, x: 20 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ delay: 1.1 }}
                                    className="relative"
                                >
                                    <label className="block text-sm font-medium text-gray-300 mb-2">Agency</label>
                                    <div className="relative">
                                        <select
                                            value={agency}
                                            onChange={(e) => setAgency(e.target.value)}
                                            className="w-full pl-12 pr-4 py-3 bg-white/10 border border-white/20 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-400 text-white placeholder-gray-400 appearance-none [&>option]:bg-gray-900 [&>option]:text-white"
                                        >
                                            <option value="" className="text-gray-400">Select agency</option>
                                            <option value="2K Events" className="text-white">2K Events Dubai</option>
                                            <option value="2K Events" className="text-white">2K Events Tunisia</option>

                                        </select>
                                        <Building2 className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                                    </div>
                                </motion.div>
                            </div>

                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: 1.2 }}
                                className="relative"
                            >
                                <label className="block text-sm font-medium text-gray-300 mb-2">Message</label>
                                <textarea
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    className="w-full px-4 py-3 bg-white/10 border border-white/20 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-400 text-white placeholder-gray-400 min-h-[150px]"
                                    placeholder="Tell us about your event..."
                                />
                            </motion.div>

                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: 1.3 }}
                                className="text-center"
                            >
                                <motion.button
                                    type="submit"
                                    id="submitBtn"
                                    whileHover={{ scale: 1.05 }}
                                    whileTap={{ scale: 0.95 }}
                                    className="px-8 py-4 bg-gradient-to-r from-purple-500 to-blue-500 rounded-lg text-white font-medium uppercase tracking-wider hover:from-purple-600 hover:to-blue-600 transition-all"
                                >
                                    Send Message
                                </motion.button>
                            </motion.div>
                        </form>
                    </motion.div>
                </div>
            </section>

            {/* Enhanced Scroll to Top Button */}
            <motion.button
                initial={{ opacity: 0 }}
                animate={{ opacity: isVisible ? 1 : 0 }}
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                className="fixed bottom-4 sm:bottom-8 right-4 sm:right-8 p-3 sm:p-4 rounded-full bg-white/10 backdrop-blur-xl hover:bg-white/20 transition-all duration-300 border border-white/10 shadow-lg"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
            >
                <ArrowRight className="w-5 h-5 sm:w-6 sm:h-6 rotate-[-90deg]" />
            </motion.button>

            <Footer />
        </div>
    );
};

export default Contact;